import { useState, useRef } from "react";
import { useTableFilterContext } from "src/context";
import { useClickOutsideModalListener } from "src/hooks/useClickOutsideModalListener";
import { SecondaryButton } from "src/components/Buttons";
import { ButtonDropdownAnchor } from "./FilterControls.styles";
import { Dropdown, DropdownRowButton } from "./Dropdown";
import { SearchIcon } from "src/assets/icons";

interface FindSelectorProps {
  setFindSelection: (selection: string) => void;
}

export default ({ setFindSelection }: FindSelectorProps) => {
  const { table } = useTableFilterContext();
  const [showFindDropdown, setShowFindDropdown] = useState(false);
  const findDropdownRef = useRef(null);
  useClickOutsideModalListener(findDropdownRef, () => {
    setShowFindDropdown(false);
  });
  return (
    <ButtonDropdownAnchor>
      <SecondaryButton onClick={() => setShowFindDropdown(!showFindDropdown)}>
        <SearchIcon />
        Find
      </SecondaryButton>
      <Dropdown clickHandleRef={findDropdownRef} show={showFindDropdown}>
        <DropdownRowButton
          onClick={() => {
            setFindSelection("first_name");
            setShowFindDropdown(false);
          }}
        >
          <SearchIcon />
          First name
        </DropdownRowButton>
        <DropdownRowButton
          onClick={() => {
            setFindSelection("last_name");
            setShowFindDropdown(false);
          }}
        >
          <SearchIcon />
          Last name
        </DropdownRowButton>
        {table === "applications" && (
          <DropdownRowButton
            onClick={() => {
              setFindSelection("application_id");
              setShowFindDropdown(false);
            }}
          >
            <SearchIcon />
            Application ID
          </DropdownRowButton>
        )}
      </Dropdown>
    </ButtonDropdownAnchor>
  );
};
